import { useCallback } from 'react';
import { CreateMerchantConnectionRequest } from '@weave/schema-gen-ts/dist/schemas/payments-platform/care-credit-integration/care_credit_integration.pb';
import { useQueryClient } from 'react-query';
import { CareCreditIntegrationV1 } from '@frontend/api-care-credit-integration';

export type UseCareCreditConnectProviderProps = {
  locationId: string | undefined;
};

export type ConnectProviderFormValues = {
  merchantNumber: string;
  last4Digits?: string;
  practiceCode?: string;
};
export const useCareCreditConnectProvider = ({ locationId }: UseCareCreditConnectProviderProps) => {
  const queryClient = useQueryClient();

  const { queryKey } = CareCreditIntegrationV1.Queries.useGetMerchantConnectionQuery({
    request: {
      locationId,
    },
    options: {
      enabled: false,
    },
  });

  const { isLoading, mutateAsync } = CareCreditIntegrationV1.Mutations.useCreateMerchantConnectionMutation({
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries(queryKey);
      },
    },
  });

  const onSaveMutation = useCallback(
    async ({ merchantNumber, last4Digits, practiceCode }: ConnectProviderFormValues) => {
      const res = await mutateAsync({
        locationId,
        merchantNumber,
        bankLast4: last4Digits,
        practiceCode: practiceCode,
      } as CreateMerchantConnectionRequest);

      return res;
    },
    [locationId, mutateAsync]
  );

  return { onSaveMutation, isMutating: isLoading };
};
